import styled, { css } from "styled-components/macro";
import colors from "@company-mrv/mrv-design-system/colors";

export const Container = styled.div`
  background: ${colors.white};
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props =>
    props.contentTransp &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.47);
      height: 100%;
    `}
`;
